import { css } from 'styled-components'

const Variables = css`
    :root {
        /* colors */
        --color-black: #0e0e0e;
        --color-black-2: #2a2a2a;
        --color-black-3: #333333;
        --color-black-4: #182039;
        --color-black-5: #6e6e6e;
        --color-black-6: #000000;
        --color-black-7: #0f0d0f;
        --color-black-8: #151717;
        --color-white: #ffffff;
        --color-red: #ff444f;
        --color-red-1: #dd573a;
        --color-red-2: #ffe8e9;
        --color-red-3: #d43e47;
        --color-red-4: #ff4449;
        --color-red-5: #ff0024;
        --color-grey: #9b9b9b;
        --color-grey-1: #f4f4f4;
        --color-grey-2: #e8e8e8;
        --color-grey-3: #646464;
        --color-grey-4: #fafbfb;
        --color-grey-5: #999999;
        --color-grey-6: #e6e9e9;
        --color-grey-7: #d6dadb;
        --color-grey-8: #f2f3f4;
        --color-grey-9: #c8d6d738;
        --color-grey-10: #c8d6d738;
        --color-grey-11: #efefef;
        --color-grey-12: #585252;
        --color-grey-13: #656868;
        --color-grey-14: #c8d6d7;
        --color-grey-15: #d8d8d8;
        --color-grey-16: #777777;
        --color-grey-17: #d6d6d6;
        --color-grey-18: #f4f4f6;
        --color-grey-19: #c2c2c2;
        --color-grey-20: #e0e0e0;
        --color-grey-21: #e5e5e5;
        --color-grey-22: #eaeced;
        --color-grey-23: #fbfbfb;
        --color-grey-24: #eff2f5;
        --color-grey-25: #f9fafc;
        --color-grey-26: #e9eaec;
        --color-grey-27: #f8a2a8;
        --color-grey-28: #f3f5f8;
        --color-grey-29: #edeeef;
        --color-grey-30: #f5f7fa;
        --color-grey-31: #f8fafc;
        --color-grey-32: #dcdee0;
        --color-grey-33: #8e9190;
        --color-grey-34: #e7e7e7;
        --color-grey-35: #f5f7f9;
        --color-grey-36: #f3f3f3;
        --color-grey-37: #fafbfd;
        --color-grey-38: #d6d7d8;
        --color-grey-39: #f7fafb;
        --color-grey-40: #b3b3b3;
        --color-grey-41: #f8fafb;
        --color-grey-42: #f5f8f9;
        --color-green: #85acb0;
        --color-blue: #4c76be;
        --color-blue-2: #365899;
        --color-blue-3: #2a3052;
        --color-blue-4: #f1f6f7;
        --color-blue-5: #85abaf;
        --color-blue-6: #4fb5b3;
        --color-blue-7: #4bb4b3;
        --color-blue-8: #003b81;
        --color-blue-9: #305f8b;
        --color-blue-10: #dee7f2;
        --color-blue-11: #4e2286;
        --color-blue-12: #2a537a;
        --color-blue-13: #c5d6e7;
        --color-yellow: #fff2df;
        --color-yellow-2: #4c3c08;
        --color-yellow-3: #ffc71b;
        --color-orange: #ff6544;
        --color-orange-2: #ff7457;
        --color-orange-3: #33140e;
        --color-green-1: #bccdce;
        --color-green-2: #e2ebec;
        --color-brown: #33140e;

        /* sizes */
        --text-size-xxs: 1.2rem;
        --text-size-xs: 1.4rem;
        --text-size-s: 1.6rem;
        --text-size-sm: 2rem;
        --text-size-m: 2.4rem;
        --text-size-l: 3.2rem;
        --text-size-xl: 4.8rem;
        --text-size-xxl: 6.4rem;

        /* TODO: match with other text-size and update <Header /> */
        --text-size-header-1: 3.6rem;
        --text-size-header-2: 2.8rem;
        --text-size-header-3: 7.2rem;
        --text-size-header-4: 4rem;
        --text-size-header-5: 4.8rem;
    }
`

export default Variables
